import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * Resumen bajo el precio (bloque resumen-ficha): se actualiza al cambiar de variante.
 */
class ResumenFicha extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.closest('.shopify-section, dialog')?.addEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.closest('.shopify-section, dialog')?.removeEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  #onSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        const updated = detail.html.querySelector(`resumen-ficha[data-block-id="${this.dataset.blockId}"]`);
        if (updated instanceof HTMLElement) morph(this, updated, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[resumen-ficha]', error);
      });
  };
}

if (!customElements.get('resumen-ficha')) customElements.define('resumen-ficha', ResumenFicha);
